import React, { useCallback } from 'react';
import { Button, IconButton, makeStyles, Snackbar } from '@material-ui/core';
import { PlatformNotificationTypes } from '../types';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import { DEFAULT_NEXT_NOTIFICATION_TIMEOUT } from '../config';
import { getNotificationMessageParts, logger } from '../utils';
import { configureModalMap, useModal } from '@topconagriculture/modal';
import { ButtonVariants, Button as LinkButton } from '@topconagriculture/react-components';
import { NotificationModal } from './NotificationModal';
import Linkify from './Linkify/Linkify';
const severityByNotificationType = {
    [PlatformNotificationTypes.FEATURE]: 'info',
    [PlatformNotificationTypes.MAINTENANCE]: 'warning',
    [PlatformNotificationTypes.SYSTEM_ERROR]: 'error',
    [PlatformNotificationTypes.GENERIC]: 'info',
    [PlatformNotificationTypes.RELEASE_NOTE]: 'info',
};
const useStyles = makeStyles((theme) => ({
    alertTitle: {
        fontWeight: theme.font.weight.bold,
        color: theme.color.background.light,
    },
    link: {
        color: 'white',
        textDecoration: 'underline',
    },
    modal: {
        zIndex: '1500 !important',
    },
    content: {
        whiteSpace: 'pre-line',
    }
}));
export var NotificationModals;
(function (NotificationModals) {
    NotificationModals["notificationModal"] = "notificationModal";
})(NotificationModals || (NotificationModals = {}));
const notificationModalMap = {
    [NotificationModals.notificationModal]: React.createElement(NotificationModal, null)
};
configureModalMap(notificationModalMap);
export const ActiveNotification = ({ notification, anchorOrigin = { vertical: 'top', horizontal: 'center' }, onClose, hasMore, onNext, nextTimeout = DEFAULT_NEXT_NOTIFICATION_TIMEOUT, dateFormatFn, config, userLocale, activeIndexList = [], }) => {
    const { i18n, t } = useTranslation();
    const classes = useStyles();
    const { dispatchOpenModal } = useModal();
    const message = getNotificationMessageParts({ notification, locale: i18n.language, localizeFn: t, dateFormatFn });
    const handleClose = useCallback((event, reason) => {
        logger.debug('handle close fired', event, reason, hasMore);
        if (reason === 'clickaway') {
            return;
        }
        if (reason === 'timeout') {
            hasMore && onNext();
            return;
        }
        onClose(notification.id);
    }, [notification === null || notification === void 0 ? void 0 : notification.id, onClose, onNext, hasMore]);
    const severity = notification ? severityByNotificationType[notification.type] : undefined;
    return (React.createElement(Snackbar, { autoHideDuration: nextTimeout, key: notification === null || notification === void 0 ? void 0 : notification.id, open: !!notification, anchorOrigin: anchorOrigin, onClose: handleClose },
        React.createElement(Alert, { severity: severity, elevation: 6, variant: "filled", action: React.createElement(React.Fragment, null,
                hasMore && (React.createElement(Button, { color: "inherit", size: "small", onClick: onNext }, t('common:next'))),
                React.createElement(IconButton, { size: "small", "aria-label": "close", color: "inherit", onClick: handleClose },
                    React.createElement(CloseIcon, { fontSize: "small" }))) },
            React.createElement(AlertTitle, { classes: { root: classes.alertTitle } }, message === null || message === void 0 ? void 0 : message.period),
            (notification === null || notification === void 0 ? void 0 : notification.type) !== PlatformNotificationTypes.RELEASE_NOTE ? (React.createElement("div", { className: classes.content },
                React.createElement(Linkify, null, message === null || message === void 0 ? void 0 : message.body))) : (React.createElement(LinkButton, { flat: true, autoWidth: true, className: classes.link, variant: ButtonVariants.tertiaryOutlined, onClick: () => dispatchOpenModal({
                    modalName: NotificationModals.notificationModal,
                    modalParams: {
                        id: notification.id,
                        config,
                        userLocale,
                        activeIndexList,
                    },
                    modalOptions: {
                        closeButtonIsVisible: true,
                        modalDialogProps: {
                            maxWidth: false,
                            className: classes.modal,
                        }
                    },
                }), label: t('common:release_alert') })))));
};
//# sourceMappingURL=ActiveNotification.js.map